import { defa }            from 'defa-object';
/**
 * defa.collections.SubscriptionPackages
 * A Collection of SubscriptionPackages with custom filters.
 * @version 1.2.0
 */
import SubscriptionPackage from 'scripts/defa/subscription-packages/model-subscription-package';

const apiHost = defa.vars.apiHost;

const api = {
	subscriptionPackages: apiHost + '/subscriptionpackages',
	promotionalPackages : apiHost + '/subscriptionpackages/promotion',
};

const SubscriptionPackages = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	url  : api.subscriptionPackages,
	model: SubscriptionPackage,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Returns a new SubscriptionPackages collection filtered by an array of ids.
	 * @param  {array}       ids  An array of ids to filter the collection by.
	 * @return {collection}       The filtered CustomerCollection.
	 */
	filterByIds: function ( ids ) {
		let array = this.filter( function ( subscription ) {
			return _.contains( ids, subscription.get( 'id' ) );
		} );
		
		return new SubscriptionPackages( array );
	},
	
	/**
	 * Extends a SubscriptionPackages collection by promotional code.
	 * @param  {Object}      options  An options object with prepaid, unitId, customerId and code.
	 * @return {collection}           The same SubscriptionPackages, but with potentially more packages.
	 */
	fetchPromotional: function ( options ) {
		this.fetch( {
			url   : api.promotionalPackages,
			remove: false,
			at    : 0,
			data  : {
				customerId   : options.customerId,
				prepaid      : options.prepaid,
				promotionCode: options.promotionCode,
				unitId       : options.unitId,
			},
		} );
	},
	
} );

export default SubscriptionPackages;